<template>
    <div class="modal fade" id="walleteditstackModal" tabindex="-1" aria-labelledby="WalletModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-md modal-dialog-centered">
            <div class="modal-content wallet_edit_stake_modal">
                <div class="modal-header modal_cmn_header">
                    <h5>{{ $t('edit-stake', 'Edit Stake') }}</h5>
                    <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetChips()">
                        <i class="fa-solid fa-xmark"></i>
                    </button> -->
                </div>
                <div class="modal-body">
                    <div class="edit_stakeed_sec">
                        <div class="edit-stack-wrapper">
                            <div class="exch_setting_edit_stakes_input">
                                <ul>
                                    <li v-for="i in 4"> 
                                        <input class="btn-thm form-control" v-model="stake[i-1]" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)"  maxlength="8">
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="header-but info-footer w-100 stake_footer_sec">
                        <button type="button" class="thm-bor-but w-50" data-bs-dismiss="modal" @click="resetChips()">
                            {{ $t('cancel', 'Cancel') }}
                        </button>
                        <a class="thm-but w-50" @click="callChangeStakeValue()">
                            {{ $t('save', 'Save') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "WalletStackModal",
    props: ['stakes'],
    data() {
        return {
            stake: this.$store.getters.userTransactionStakes || this.stakes
        };
    },
    mounted() {
        this.resetChips();
    },
    methods: {
        callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast('Stake value must be between 100 to 1Cr.')
                return

            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$successToast('Saved Successfully')
            this.$helper.closeModal('walleteditstackModal');
        },
        resetChips(){
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
    }
};
</script>